(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-reveal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeGiftReveals = (root = document) => {
      root.querySelectorAll('[data-gift-reveal]').forEach((stage) => {
        if (stage.dataset.initialized === 'true') return;

        stage.dataset.initialized = 'true';
        stage.dataset.step = '0';

        const gift = stage.querySelector('[data-gift]');
        const product = stage.querySelector('[data-product]');
        const status = stage.parentElement.querySelector('[data-status]');
        const progressDots = stage.parentElement.querySelectorAll('[data-progress-dot]');
        const canvas = stage.querySelector('[data-confetti]');
        const context = canvas?.getContext('2d');

        let step = 0;
        let confettiAnimation;

        const messages = [
          stage.dataset.tapText || 'Tippe auf das Geschenk',
          'Da ist etwas drin …',
          'Nur noch ein bisschen …',
          'Fast geschafft …',
          stage.dataset.finalText || 'Überraschung!'
        ];

        const updateProgress = () => {
          progressDots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === Math.min(step, 3));
          });
        };

        const resizeCanvas = () => {
          if (!canvas) return;

          const bounds = stage.getBoundingClientRect();
          const ratio = Math.min(window.devicePixelRatio || 1, 2);

          canvas.width = Math.round(bounds.width * ratio);
          canvas.height = Math.round(bounds.height * ratio);
          canvas.style.width = `${bounds.width}px`;
          canvas.style.height = `${bounds.height}px`;

          context?.setTransform(ratio, 0, 0, ratio, 0, 0);
        };

        const launchConfetti = () => {
          if (!canvas || !context) return;

          resizeCanvas();

          const width = canvas.clientWidth;
          const height = canvas.clientHeight;
          const colors = ['#f4c542', '#ff6b6b', '#4ecdc4', '#7857ff', '#ff9f1c', '#ffffff'];

          const pieces = Array.from({ length: 130 }, () => ({
            x: width / 2 + (Math.random() - 0.5) * 100,
            y: height * 0.42,
            width: 5 + Math.random() * 7,
            height: 8 + Math.random() * 12,
            velocityX: (Math.random() - 0.5) * 13,
            velocityY: -7 - Math.random() * 12,
            gravity: 0.24 + Math.random() * 0.12,
            rotation: Math.random() * Math.PI,
            rotationSpeed: (Math.random() - 0.5) * 0.3,
            color: colors[Math.floor(Math.random() * colors.length)],
            opacity: 1
          }));

          let frame = 0;
          cancelAnimationFrame(confettiAnimation);

          const render = () => {
            context.clearRect(0, 0, width, height);

            pieces.forEach((piece) => {
              piece.x += piece.velocityX;
              piece.y += piece.velocityY;
              piece.velocityY += piece.gravity;
              piece.rotation += piece.rotationSpeed;

              if (frame > 75) {
                piece.opacity = Math.max(0, piece.opacity - 0.016);
              }

              context.save();
              context.globalAlpha = piece.opacity;
              context.translate(piece.x, piece.y);
              context.rotate(piece.rotation);
              context.fillStyle = piece.color;
              context.fillRect(
                -piece.width / 2,
                -piece.height / 2,
                piece.width,
                piece.height
              );
              context.restore();
            });

            frame += 1;

            if (frame < 145) {
              confettiAnimation = requestAnimationFrame(render);
            } else {
              context.clearRect(0, 0, width, height);
            }
          };

          render();
        };

        const revealGift = () => {
          if (step >= 4) return;

          step += 1;
          stage.dataset.step = String(step);

          gift.classList.remove('is-hit');
          void gift.offsetWidth;
          gift.classList.add('is-hit');

          if (status) {
            status.textContent = messages[step];
          }

          updateProgress();

          if (step === 4) {
            product?.setAttribute('aria-hidden', 'false');
            gift.setAttribute('aria-hidden', 'true');

            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              launchConfetti();
            }
          }
        };

        gift?.addEventListener('click', revealGift);
        window.addEventListener('resize', resizeCanvas);

        resizeCanvas();
        updateProgress();
      });
    };

    document.addEventListener('DOMContentLoaded', () => {
      initializeGiftReveals();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initializeGiftReveals(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
